module.exports = __webpack_public_path__ + "assets/img/cde43e586baed7c62e8aa27e6dfad318.png";